/**
 * ChatVideoCallInfoRemapper
 *
 * Maps ChatVideoCallInfoDto (data layer) → ChatVideoCallInfoEntity (domain).
 * Flutter source: lib/data/models/chat_video_call_info.dart
 */
import type { ChatVideoCallInfoDto } from '@/data/dtos/info/chatVideoCallInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { ChatVideoCallInfoEntity } from '@/domain/entities/info/chatVideoCallInfoEntity';

export class ChatVideoCallInfoRemapper {
  static fromDto(dto: ChatVideoCallInfoDto): ChatVideoCallInfoEntity {
    return { ...dto };
  }

  static fromJson(data: JsonObject): ChatVideoCallInfoDto {
    return {
      videoCallMessageId: (data['videoCallMessageId'] as string | undefined) ?? '',
      peerUserId: (data['peerUserId'] as string | undefined) ?? '',
      peerUsername: (data['peerUsername'] as string | undefined) ?? '',
      peerUserProfile: (data['peerUserProfile'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): ChatVideoCallInfoDto[] {
    return dataList.map(ChatVideoCallInfoRemapper.fromJson);
  }
}
